import React from 'react';
import Products from './Products';
import {
  AuthProvider,
  DialogProvider,
  FiltersProvider,
  ProductsProvider,
  ValuesProvider
} from 'contexts';

export default () => {
  return (
    <AuthProvider>
      <ProductsProvider>
        <DialogProvider>
          <FiltersProvider>
            <ValuesProvider>
              <Products/>
            </ValuesProvider>
          </FiltersProvider>
        </DialogProvider>
      </ProductsProvider>
    </AuthProvider>
  );
}